<template>
  <svg viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg" style="width: 1em; height: 0.9em;">
    <rect x="1.125" y="5" width="18" height="12" rx="2" stroke="currentColor" stroke-width="1.5"/>
    <path d="M6.125 3C6.125 1.89543 7.02043 1 8.125 1H12.125C13.2296 1 14.125 1.89543 14.125 3V5H6.125V3Z" stroke="currentColor" stroke-width="1.5"/>
    <path d="M1.125 10H19.125" stroke="currentColor" stroke-width="1.5"/>
  </svg>
</template>